var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	653: () => (loadStrictSingletonVersion("default", "@angular/core", false, [2,20,3,26], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_effect_mjs-node_modules_angular_core_fesm2022_weak-b3208f"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(7017))))))),
	4866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(1340))))))),
	7931: () => (loadStrictSingletonVersion("default", "@angular/common", false, [2,20,3,26], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(7610))))))),
	2778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(3620))))))),
	1419: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [2,20,3,26], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(8015))))))),
	8046: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [2,20,3,26], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(7276))))))),
	9679: () => (loadStrictSingletonVersion("default", "@angular/router", false, [2,20,3,26], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(6039))))))),
	9772: () => (loadStrictSingletonVersion("default", "@ngx-translate/core", false, [1,14,0,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_ngx-translate_core_fesm2020_ngx-translate-core_mjs")]).then(() => (() => (__webpack_require__(597))))))),
	6439: () => (loadStrictSingletonVersion("default", "@ngx-translate/http-loader", false, [1,7,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_http-loader_fesm2020_ngx-translate-http-loader_mjs").then(() => (() => (__webpack_require__(5101))))))),
	2676: () => (loadStrictSingletonVersion("default", "@pichincha/angular-sdk/storage", false, [4,2,5,2], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_pichincha_typescript-storage_build_pichincha-sdk_bundle_js"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(7471))))))),
	1791: () => (loadStrictSingletonVersion("default", "@ng-idle/core", false, [1,13,0,0], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_ng-idle_core_fesm2020_ng-idle-core_mjs")]).then(() => (() => (__webpack_require__(8177))))))),
	8410: () => (loadStrictSingletonVersion("default", "@pichincha/angular-sdk/http", false, [4,2,5,2], () => (Promise.all([__webpack_require__.e("default-node_modules_pichincha_typescript-storage_build_pichincha-sdk_bundle_js"), __webpack_require__.e("default-webpack_sharing_consume_default_pichincha_http_pichincha_http"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(1660))))))),
	7306: () => (loadStrictSingletonVersion("default", "@pichincha/angular-sdk/auth", false, [4,2,5,2], () => (__webpack_require__.e("default-node_modules_pichincha_angular-sdk_fesm2022_pichincha-angular-sdk-auth_mjs").then(() => (() => (__webpack_require__(3376))))))),
	5778: () => (loadStrictSingletonVersion("default", "uuid", false, [1,14,0,0], () => (__webpack_require__.e("node_modules_uuid_dist_index_js").then(() => (() => (__webpack_require__(3803))))))),
	8047: () => (loadStrictSingletonVersion("default", "@angular-architects/module-federation-tools", false, [2,20,0,0], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(3007))))))),
	4545: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [2,20,3,26], () => (__webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs").then(() => (() => (__webpack_require__(4456))))))),
	709: () => (loadStrictSingletonVersion("default", "@pichincha/bb-commons/internationalization", false, [4,1,1,11], () => (Promise.all([__webpack_require__.e("default-node_modules_pichincha_typescript-storage_build_pichincha-sdk_bundle_js"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(1730))))))),
	6475: () => (loadStrictSingletonVersion("default", "@pichincha/bb-commons/interceptor", false, [4,1,1,11], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_pichincha_angular-sdk_eventbus_pichincha_angular-sdk_-26c2a1"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(9199))))))),
	1032: () => (loadStrictSingletonVersion("default", "@pichincha/angular-sdk/external-assets", false, [4,2,5,2], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(1997))))))),
	7902: () => (loadStrictSingletonVersion("default", "@ng-idle/keepalive", false, [1,13,0,0], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(4153))))))),
	9750: () => (loadStrictSingletonVersion("default", "angular-google-tag-manager", false, [1,1,9,0], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(409))))))),
	2607: () => (loadStrictSingletonVersion("default", "@bp/encryption-web", false, [4,0,7,0], () => (__webpack_require__.e("node_modules_bp_encryption-web_dist_index_js").then(() => (() => (__webpack_require__(2228))))))),
	2327: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [2,20,3,26], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(5689))))))),
	755: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [2,20,3,26], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(2867))))))),
	9672: () => (loadStrictSingletonVersion("default", "@pichincha/http", false, [4,0,10,4], () => (__webpack_require__.e("node_modules_pichincha_angular-sdk_node_modules_pichincha_http_build_pichincha-sdk_bundle_js").then(() => (() => (__webpack_require__(6201))))))),
	8802: () => (loadStrictSingletonVersion("default", "@pichincha/angular-sdk/eventbus", false, [4,2,5,2], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_pichincha_angular-sdk_fesm2022_pichincha-angular-sdk-eventbus_mjs")]).then(() => (() => (__webpack_require__(2546)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		653
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		4866
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		7931
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		2778
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		1419
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		8046
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		9679
	],
	"default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core-webpack_sharing-7bb45d": [
		9772,
		6439
	],
	"default-webpack_sharing_consume_default_pichincha_angular-sdk_storage_pichincha_angular-sdk_storage": [
		2676
	],
	"default-webpack_sharing_consume_default_ng-idle_core_ng-idle_core": [
		1791
	],
	"src_bootstrap_ts": [
		8410,
		7306,
		5778,
		8047,
		4545,
		709,
		6475,
		1032,
		7902,
		9750,
		2607
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		2327,
		755
	],
	"default-webpack_sharing_consume_default_pichincha_http_pichincha_http": [
		9672
	],
	"default-webpack_sharing_consume_default_pichincha_angular-sdk_eventbus_pichincha_angular-sdk_-26c2a1": [
		8802
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}